import { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import TabContentHeader from '../../components/TabContentHeader.jsx';
import { TabContentProps } from '../../types/singleFlow.js';
import DateRangeBoundary from '../FlowForm/DateRangeBoundary.jsx';
import MainInformation from '../FlowForm/MainInformation.jsx';

const MainInformationTab: FC<TabContentProps> = () => {
  const { t } = useTranslation('@myn/approval_v2');

  return (
    <div>
      <TabContentHeader
        title={t('Main information')}
        description={t(
          'Set the key details of your approval flow and specify the dates when it applies',
        )}
      />
      <div className="mt-4 grid gap-6">
        <MainInformation />
        <div className="grid lg:grid-cols-2">
          <DateRangeBoundary />
        </div>
      </div>
    </div>
  );
};

export default MainInformationTab;
